import { api } from "@/lib/api";
import { BaseService } from "./base.service";
import { ApiResponse } from "@/interfaces/api.interface";

export class UserGroupService extends BaseService {
  constructor() {
    super("UserGroup");
  }

  async getMyUserGroups(): Promise<ApiResponse<any>> {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/UserGroup/my-groups`
      );
      return { data: res.data, error: null };
    } catch (error: any) {
      return { data: null, error: this.handleError(error) };
    }
  }

  async syncUserInGroups(userId: string, userGroupIds: string[]) {
    return api.post(`${process.env.REACT_APP_BASE_URL}/api/UserGroup/sync-user`, {
      userId,
      userGroupIds,
    });
  }

  async syncEngineerInGroups(userId: string, userGroupIds: string[]) {
    return api.post(`${process.env.REACT_APP_BASE_URL}/api/UserGroup/sync-engineer`, {
      userId,
      userGroupIds,
    });
  }

  async getUserGroupsWithCompanyInfo(projectId: string, levelId: string): Promise<ApiResponse<any>> {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/UserGroup/with-company-info?projectId=${projectId}&levelId=${levelId}`
      );
      return { data: res.data, error: null };
    } catch (error: any) {
      return { data: null, error: this.handleError(error) };
    }
  }
}

export const userGroupSvc = new UserGroupService();
